import React, {memo, useState} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Collapse from 'react-bootstrap/lib/Collapse';
import {cleanHtml} from 'helpers/commonHelper';

const Alert = ({collapsed, message, type, classes, children}) => {
  const [show, setShow] = useState(false);

  const toggleShow = () => {
    setShow((show) => !show);
  };

  const alertClasses = classnames(`alert alert-${type} text-small`, classes);

  return (
    <>
      <div className={alertClasses}>
        {
          collapsed &&
            <>
              <i
                className={`float-right text-muted icon icon-${show ? 'up' : 'down'}-arrow`}
                onClick={toggleShow}
              />
              {!show && <span
                className="overflow-hidden"
                style={{display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical'}}
                dangerouslySetInnerHTML={{__html: cleanHtml(message)}}
              />}
            </>
        }
        <Collapse in={show || !collapsed}>
          <div>
            <span dangerouslySetInnerHTML={{__html: cleanHtml(message)}} />
          </div>
        </Collapse>
        {children}
      </div>
    </>
  );
};

Alert.propTypes = {
  collapsed: PropTypes.bool,
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  type: PropTypes.oneOf(['warning', 'success', 'info', 'danger']),
  classes: PropTypes.string,
  children: PropTypes.node
};

Alert.defaultProps = {
  type: 'warning'
};

export default memo(Alert);
